class Impact {
  constructor(c, p, q, rationale) {
    if (typeof(c) === 'string') {
      c = c.replace('$', '');
    }

    this.c = isNaN(parseInt(c, 10))? 0 : parseInt(c, 10);
    this.p = isNaN(parseInt(p, 10))? 0 : parseInt(p, 10);
    this.q = isNaN(parseInt(q, 10))? 0 : parseInt(q, 10);
    this.rationale = (rationale && rationale.length > 0)? rationale : null;
  }

  add(other) {
    let impact = new Impact(0,0,0);
    impact.c = this.c + other.c;
    impact.p = this.p + other.p;
    impact.q = this.q + other.q;
    return impact;
  }

  normalize() {
    let impact = this.add(new Impact(0,0,0));
    impact.p = Math.min(impact.p, 20);
    impact.q = Math.min(impact.q, 20);
    return impact;
  }

  bestComponents(other) {
    return new Impact(
      Math.max(this.c, other.c),
      Math.max(this.p, other.p),
      Math.max(this.q, other.q)
    );
  }

  isGameOver() {
    return this.c < 0 || this.p < 0 || this.q < 0;
  }
}

export default Impact;



// WEBPACK FOOTER //
// ./src/models/Impact.js